import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useOnlineStatus } from '../../utils/onlineStatus';

export default function GifAttachment({ gif, className = '' }) {
  const online = useOnlineStatus();
  const [failed, setFailed] = useState(false);
  if (!gif) return null;

  const title = gif.title || 'GIF';
  const showImage = online && !failed && (gif.url || gif.previewUrl);
  const rootClass = ['chat-bubble__gif-wrap', 'giphy-attachment', className, showImage ? '' : 'giphy-attachment--offline']
    .filter(Boolean)
    .join(' ');

  return (
    <figure className={rootClass}>
      {showImage ? (
        <img
          className="chat-bubble__gif"
          src={gif.url || gif.previewUrl}
          alt={title}
          loading="lazy"
          onError={() => setFailed(true)}
        />
      ) : (
        <div className="giphy-attachment__placeholder" role="img" aria-label={`${title} GIF`}>
          <strong>{title}</strong>
          <span>GIF available when online</span>
        </div>
      )}
      <figcaption>Powered by GIPHY</figcaption>
    </figure>
  );
}

GifAttachment.propTypes = {
  gif: PropTypes.shape({
    title: PropTypes.string,
    url: PropTypes.string,
    previewUrl: PropTypes.string,
  }),
  className: PropTypes.string,
};
